import { queryOptions, useMutation } from '@tanstack/react-query';
import { axiosDelete, axiosGet, axiosPost, axiosPut } from '../utils/api';

export const getAllLeadAgents = ({ accessToken, params }) =>
  queryOptions({
    queryKey: ['/users', params],
    queryFn: async () => {
      const res = await axiosGet('/users/leadAgents', { params }, accessToken);
      return res.data;
    },
  });

export const useApproveLeadAgent = () =>
  useMutation({
    mutationFn: ({ id }) => {
      return axiosPut(`/users/leadAgents/${id}/approve`, {});
    },
  });

export const useCreateUser = () =>
  useMutation({
    mutationFn: ({ data }) => {
      return axiosPost('/users', data);
    },
  });

export const useUpdateUser = () =>
  useMutation({
    mutationFn: ({ id, data }) => {
      return axiosPut(`/users/${id}`, data);
    },
  });

export const useDeleteUser = () =>
  useMutation({
    mutationFn: ({ id, data }) => {
      return axiosDelete(`/users/${id}`, data);
    },
  });
